module.exports = __webpack_public_path__ + "media/images/home-bf4b5064ac3384571f1adb41e320093d.jpg";